import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchRelationsBeta = withSuspense(lazy(() => import('./relation-search')));
export default SearchRelationsBeta;
